import React from 'react'
import './AdminHowTo.css'
import AdminNavigation from './AdminNavigation'

const AdminHowTo = () => {
	const howToVideos = [
		{
			title: 'Create a New Tournament',
			duration: '3:51',
			description:
				'Set up a new tournament, create divisions and teams, and archive any old tournaments.',
			url: 'https://www.youtube.com/watch?v=JM360HPpUQI',
		},
		{
			title: 'Uploading Teams',
			duration: '3:45',
			description: 'Upload teams from the spreadsheet.',
			url: 'https://www.youtube.com/watch?v=KBMk9cIrESU',
		},
		{
			title: 'Adding Games and Events',
			duration: '',
			description:
				'Add games, add events, edit games or events, and view the schedule.',
			url: 'https://www.youtube.com/watch?v=VoYV4mZmDE4',
		},
		{
			title: 'Entering Game Results',
			duration: '',
			description:
				'Enter game results, including score, player stats, goalie stats, and penalties.',
			url: 'https://www.youtube.com/watch?v=6Gjvur7SOIM',
		},
		{
			title: 'Archiving Teams, View Player History',
			duration: '',
			description:
				'Learn what archiving means and why old teams should be archived.',
			url: 'https://www.youtube.com/watch?v=uUeSIFwbEus',
		},
		{
			title: "Add a Player's Profile Picture",
			duration: '1:32',
			description:
				'Add a player profile picture for their personal stats page.',
			url: 'https://www.youtube.com/watch?v=3V2kgr5r7xI',
		},
	]

	const getYouTubeVideoId = (url) => {
		try {
			const parsedUrl = new URL(url)

			if (parsedUrl.hostname.includes('youtu.be')) {
				return parsedUrl.pathname.slice(1)
			}

			return parsedUrl.searchParams.get('v')
		} catch {
			return ''
		}
	}

	return (
		<React.Fragment>
			<AdminNavigation />

			<main className='adminHowTo'>
				<section className='adminHowTo__hero'>
					<h1>How-To Videos</h1>

					<p className='adminHowTo__heroText'>
						Step-by-step video tutorials to help you set up and manage your
						site.
					</p>
				</section>

				<section className='adminHowTo__helpBar'>
					<p>
						Need help? Email{' '}
						<a href='mailto:matt@shireystatsandstandings.com'>
							matt@shireystatsandstandings.com
						</a>{' '}
						or call/text <a href='tel:7248758661'>724-875-8661</a>.
					</p>
				</section>

				<section className='adminHowTo__videos'>
					{howToVideos.map((video, index) => {
						const videoId = getYouTubeVideoId(video.url)

						const thumbnailUrl = videoId
							? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
							: ''

						return (
							<article className='adminHowTo__videoCard' key={video.url}>
								<div className='adminHowTo__videoNumber'>{index + 1}</div>

								<a
									href={video.url}
									target='_blank'
									rel='noopener noreferrer'
									className='adminHowTo__thumbnailLink'
									aria-label={`Watch ${video.title}`}
								>
									<img
										src={thumbnailUrl}
										alt={`${video.title} video thumbnail`}
										className='adminHowTo__thumbnail'
									/>

									<div className='adminHowTo__playButton'>
										<div className='adminHowTo__playTriangle'></div>
									</div>
								</a>

								<div className='adminHowTo__videoInfo'>
									<div className='adminHowTo__videoTitleRow'>
										<a
											href={video.url}
											target='_blank'
											rel='noopener noreferrer'
											className='adminHowTo__videoTitle'
										>
											{video.title}
										</a>

										{video.duration && (
											<span className='adminHowTo__duration'>
												{video.duration}
											</span>
										)}
									</div>

									<p className='adminHowTo__description'>{video.description}</p>
								</div>
							</article>
						)
					})}
				</section>

				<section className='adminHowTo__footerMessage'>
					<div>
						<h3>More videos coming soon!</h3>

						<p>
							Check back as more tutorials are added to help you manage your
							site.
						</p>
					</div>
				</section>
			</main>
		</React.Fragment>
	)
}

export default AdminHowTo
